import evRepairLogo from '../assets/ev-repair-logo.png';
import userIcon from '../assets/dp.png'
import more from '../assets/icons/more.png'
import { useRecoilState } from 'recoil';
import uiConfigAtom from '../atoms/uiConfigAtom';
import { app_version, url } from '../utils/config';
import { useState } from 'react';
import UpdateProfileImage from '../modals/UpdateProfileImage';
import myInfoAtom from '../atoms/myInfoAtom';
import { Link } from 'react-router-dom';
import navMenuStateAtom from '../atoms/navMenuState';

function Nav() {
    // const userName = window.localStorage.getItem('userName').split(' ');
    const [ uiConfig ] = useRecoilState(uiConfigAtom);
    const [ showNavMenu, setShowNavMenu ] = useRecoilState(navMenuStateAtom)
    const [ showModal, setShowModal ] = useState(false)
    const [ myInfo, setMyInfo ] = useRecoilState(myInfoAtom);


    function logout() {
        window.localStorage.clear();
        window.location.reload()
    }
   
    // console.log(uiConfig)

    return(
        <>
            {
                showModal && <UpdateProfileImage setShowModal={setShowModal} />
            }
            <div className="flex px-3 justify-between bg-white items-center fixed top-0 left-0 right-0" style={{backgroundColor: uiConfig?.primaryColor?.hex}}>
                <div className='flex justify-center items-center'>
                    <Link to={'/'}>
                        <div className='flex justify-center items-center'>
                        <img alt='logo' src={uiConfig?.logos?.landingLogo ? url + '/images/' + uiConfig.logos.landingLogo : evRepairLogo} className='h-[75px]' />
                        <div className='flex flex-col'>
                        <p className='capitalize m-0 p-0 text-md font-bold'>Manager Portal</p>
                        <span className='text-[10px] m-0 p-0'>{app_version}</span>
                        </div>
                        </div>
                    </Link>
                </div>
                <div className='flex mr-2'>
                    <div className='rounded-full flex justify-center items-center font-medium p-2 cursor-pointer'>
                        <img 
                            alt='icon' src={myInfo.profileImage && myInfo.profileImage.length !== 0 ? url + '/images/' + myInfo.profileImage : (uiConfig?.icons?.managerIcon ? url + '/images/' + uiConfig.icons.managerIcon : userIcon)} 
                            className='rounded-full' 
                            height={30}
                            width={30}
                        />
                    </div>
                    <div className='ml-4 flex flex-col justify-center'>
                        <div className='text-gray-700 text-sm font-semibold'>Name</div>
                        <div className='text-gray-400 text-xs font-semibold'>Manager</div>
                    </div>
                    <div className='flex items-center mx-8'>
                        <img src={more} className={`cursor-pointer ${showNavMenu && 'rotate-180'}`} onClick={() => setShowNavMenu(!showNavMenu)}/>
                    </div>
                </div>
            </div>
            <div>
                {
                    showNavMenu &&
                    <ul className='fixed top-16 right-8 py-2 bg-gray-100 rounded-md font-semibold text-gray-500' onClick={() => setShowNavMenu(false)}>
                        <li className='py-1 px-8 hover:text-black cursor-pointer' onClick={() => setShowModal(true)}>Update Image</li>
                        <hr />
                        <li className='py-1 px-8 hover:text-gray-900 cursor-pointer' onClick={() => logout()}>Logout</li>
                    </ul>
                }
            </div>
        </>
    )
} 

export default Nav;